export let LABLES = {
    PDF_TITLE: "PDF Title",
    COUNTRY: "Country",
    STATE: "State",
    DIRECTORS: "No. of Directors",
    COMPANY_NAME: "Company Name",
    DATE_OF_INCORPORATION: "Date of Incorporation",
    CORPORATION_NUMBER: "Corporation Number",
    REGISTERED_OFFICE_ADDRESS: "Registered Office Address",
    RECORD_ADDRESS: "Record Address",
    PLACES_OF_BUSINESS_ADDRESS: "Place of Business Address",
    DIRECTOR_NAME: "Director Name",
    DIRECTOR_FULL_ADDRESS: "Director Full Address",
    DIRECTOR_TITLE: "Director Title",
    AS_OF_DATE: "As of Date",
    CONTACT_NUMBER: "Contact Number",
    FAX: "Fax",
    EMAIL: "Email",
    WEBSITE: "Website",
    APPOINTMENT_CALENDER_LINK: "Appointment Calendar Link",
    INCORPORATOR_NAME: "Incorporator Name",
    FIRM_NAME: "Firm Name",
    FULL_ADDRESS: "Full Address",
    BAR_STATE: "Bar State"
};

export let NAMES = {
    [LABLES.PDF_TITLE]: "pdfTitle",
    [LABLES.COUNTRY]: "country",
    [LABLES.STATE]: "state",
    [LABLES.DIRECTORS]: "noOfDirectors",
    [LABLES.COMPANY_NAME]: "companyName",
    [LABLES.DATE_OF_INCORPORATION]: "dateOfIncorporation",
    [LABLES.CORPORATION_NUMBER]: "corporationNumber",
    [LABLES.REGISTERED_OFFICE_ADDRESS]: "registeredOfficeAddress",
    [LABLES.RECORD_ADDRESS]: "recordAddress",
    [LABLES.PLACES_OF_BUSINESS_ADDRESS]: "placeOfBusinessAddress",
    [LABLES.DIRECTOR_NAME]: "directorName",
    [LABLES.DIRECTOR_FULL_ADDRESS]: "directorFullAddress",
    [LABLES.DIRECTOR_TITLE]: "directorTitle",
    [LABLES.AS_OF_DATE]: "asOfDate",
    [LABLES.CONTACT_NUMBER]: "contactNumber",
    [LABLES.FAX]: "fax",
    [LABLES.EMAIL]: "email",
    [LABLES.WEBSITE]: "website",
    [LABLES.APPOINTMENT_CALENDER_LINK]: "appointmentCalendarLink",
    [LABLES.INCORPORATOR_NAME]: "incorporatorName",
    [LABLES.FIRM_NAME]: "firmName",
    [LABLES.FULL_ADDRESS]: "fullAddress",
    [LABLES.BAR_STATE]: "barState"
};

export let PLACEHOLDERS = {
    [LABLES.PDF_TITLE]: "Enter Title",
    [LABLES.COUNTRY]: "Select Country",
    [LABLES.STATE]: "Select State",
    [LABLES.DIRECTORS]: "Select No.",
    [LABLES.COMPANY_NAME]: "ABC Corporation",
    [LABLES.DATE_OF_INCORPORATION]: "01 Oct, 2022",
    [LABLES.CORPORATION_NUMBER]: "12312341211",
    [LABLES.REGISTERED_OFFICE_ADDRESS]: "1234 Innovation Street, Suite 200, Tech City, CA 98765",
    [LABLES.RECORD_ADDRESS]: "1234 Innovation Street, Suite 200, Tech City, CA 98765",
    [LABLES.PLACES_OF_BUSINESS_ADDRESS]: "1234 Innovation Street, Suite 200, Tech City, CA 98765",
    [LABLES.DIRECTOR_NAME]: "Alex Brown",
    [LABLES.DIRECTOR_FULL_ADDRESS]: "1234 Innovation Street, Suite 200, Tech City, CA 98765",
    [LABLES.DIRECTOR_TITLE]: "President",
    [LABLES.AS_OF_DATE]: "01 Oct, 2022",
    [LABLES.CONTACT_NUMBER]: "12312341211",
    [LABLES.FAX]: "12 2131244",
    [LABLES.EMAIL]: "john@mail.com",
    [LABLES.WEBSITE]: "www.accounting.com",
    [LABLES.APPOINTMENT_CALENDER_LINK]: "www.accounting.com",
    [LABLES.INCORPORATOR_NAME]: "ABC Corporation",
    [LABLES.FIRM_NAME]: "Firm Name",
    [LABLES.FULL_ADDRESS]: "1234 Innovation Street, Suite 200, Tech City, CA 98765",
    [LABLES.BAR_STATE]: "Select Bar State"
};
